import React, { useContext, useState, useRef } from "react";

import FiltersDrawer from "./FiltersDrawer.jsx";
import IconButton from "@components/general/IconButton.jsx";
import FilterIcon from '@assets/Filter.svg';
import Result from "./Result.jsx"
import NoResults from './NoResults.jsx';
import ResultsLoading from './ResultsLoading.jsx';
import { DealerContext } from '@contexts/DealerContext.jsx';
import MapPin from '@assets/MapPin.svg';
import { translate } from "../../../utility/strings.js";

const ResultsList = ({ openMap, utilityBarRef }) => {

  const ref = useRef(null);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const { dealers, loading, setHoverIndex } = useContext(DealerContext);

  return (
    <div ref={ref} className="ft_dealer-locator__results__list">
      {loading ?
        <ResultsLoading />
        :
        (dealers && dealers.length ?
          <>
            <div className="ft_dealer-locator__results__utility-bar" ref={utilityBarRef}>
              <span className="ft_dealer-locator__results-icon">
                <MapPin />
              </span>
              <div className="ft_dealer-locator__results__search-bar__title subtitle-2">{translate("dealer_locator.dealer_count", "Stores", dealers.length)}</div>
              <button className="button button--sm button--inline md:hidden" onClick={openMap}>Map</button>
              <IconButton title="Filter Dealers" className="button--inline ft_dealer-locator__filter-button" onClick={() => setFiltersOpen(true)}>
                <FilterIcon />
              </IconButton>
            </div>
            {dealers.map((dealer, index) => <Result onMouseEnter={() => { setHoverIndex(index + 1) }} onMouseLeave={() => { setHoverIndex(-1) }} key={`result-${index}`} index={index} dealer={dealer} className={"ft_dealer-locator__results__list__item"} />)}
            <FiltersDrawer open={filtersOpen} onClose={() => { console.log("closed"); setFiltersOpen(false)}} />
          </>
          :
          <NoResults />
        )
      }
    </div>
  );

}

export default ResultsList;
